import { render } from "./AllPromotions.vue?vue&type=template&id=c1b06358&scoped=true"
import script from "./AllPromotions.vue?vue&type=script&lang=js"
export * from "./AllPromotions.vue?vue&type=script&lang=js"

import "./AllPromotions.vue?vue&type=style&index=0&id=c1b06358&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b06358"]])

export default __exports__